import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import './timeline4.css'

const Timeline4 = (props) => {
  return (
    <div className="thq-section-padding">
      <div className="timeline4-max-width thq-section-max-width">
        <div className="timeline4-container11">
          <h2>
            {props.title1 ?? (
              <Fragment>
                <h2 className="timeline4-text31 thq-heading-2">Our Journey</h2>
              </Fragment>
            )}
          </h2>
          <span>
            {props.content1 ?? (
              <Fragment>
                <span className="timeline4-text32 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
                  The Commonwealth Artificial Intelligence Consortium (CAIC) journey focuses on empowering Commonwealth nations, particularly small states, through AI-driven innovation. With leadership, governance, and multistakeholder collaboration, CAIC aims to foster sustainable development, bridge the digital divide, and support economic growth across vulnerable economies.
                </span>
              </Fragment>
            )}
          </span>
          <div className="timeline4-container12">
            <img src="/caic_nvidia.jpg" alt="CAIC NVIDIA" className="timeline4-image" />
          </div>
        </div>
        <div className="timeline4-timeline-container">
          <div className="timeline4-line"></div>
          <div className="timeline4-step">
            <div className="timeline4-dot"></div>
            <div className="timeline4-content">
              <h3>
                {props.date1 ?? (
                  <Fragment>
                    <h3 className="timeline4-text24 thq-heading-3">April 2023</h3>
                  </Fragment>
                )}
              </h3>
              <h3>
                {props.card1Heading ?? (
                  <Fragment>
                    <h3 className="timeline4-text23 thq-heading-3">Formation of the Consortium</h3>
                  </Fragment>
                )}
              </h3>
              <span>
                {props.card1Content ?? (
                  <Fragment>
                    <span className="timeline4-text30 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
                      Through April to June 2023, Joint Consortium of Private sector was developed. A steering committee on CAIC was setup and the Terms of Reference was signed and accepted.
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="timeline4-step">
            <div className="timeline4-dot"></div>
            <div className="timeline4-content">
              <h3>
                {props.date2 ?? (
                  <Fragment>
                    <h3 className="timeline4-text26 thq-heading-3">August 2023</h3>
                  </Fragment>
                )}
              </h3>
              <h3>
                {props.card2Heading ?? (
                  <Fragment>
                    <h3 className="timeline4-text34 thq-heading-3">AI for Youth</h3>
                  </Fragment>
                )}
              </h3>
              <span>
                {props.card2Content ?? (
                  <Fragment>
                    <span className="timeline4-text25 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
                      Launched at the Commonwealth Youth Ministers meeting, AI for Youth initiative was launched.
                    </span>
                  </Fragment>
                )}
              </span>
              <div className="timeline4-container19">
                <button type="button" className="thq-button-filled">
                  <span>
                    {props.card2Action1 ?? (
                      <Fragment>
                        <span className="timeline4-text35">Learn More..</span>
                      </Fragment>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div className="timeline4-step">
            <div className="timeline4-dot"></div>
            <div className="timeline4-content">
              <h3>
                {props.date4 ?? (
                  <Fragment>
                    <h3 className="timeline4-text33 thq-heading-3">September 2023</h3>
                  </Fragment>
                )}
              </h3>
              <h3>
                {props.card4Heading ?? (
                  <Fragment>
                    <h3 className="timeline4-text27 thq-heading-3">Launch of Multi-year initiatives</h3>
                  </Fragment>
                )}
              </h3>
              <span>
                {props.card4Content ?? (
                  <Fragment>
                    <span className="timeline4-text28 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
                      Since September 2023, the CAIC launched multiple projects in collaboration with the Consortium Partners. To name a few - AI Academy, AI Youth Incubator, AI Policy Toolkit, AI Make-a-Thon....
                    </span>
                  </Fragment>
                )}
              </span>
              <div className="timeline4-container25">
                <button type="button" className="thq-button-filled">
                  <span>
                    {props.card4Action1 ?? (
                      <Fragment>
                        <span className="timeline4-text29">View Details...</span>
                      </Fragment>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Timeline4.defaultProps = {
  card1Heading: undefined,
  date1: undefined,
  card2Content: undefined,
  date2: undefined,
  card4Heading: undefined,
  card4Content: undefined,
  card4Action1: undefined,
  card1Content: undefined,
  title1: undefined,
  content1: undefined,
  date4: undefined,
  card2Heading: undefined,
  card2Action1: undefined,
}

Timeline4.propTypes = {
  card1Heading: PropTypes.element,
  date1: PropTypes.element,
  card2Content: PropTypes.element,
  date2: PropTypes.element,
  card4Heading: PropTypes.element,
  card4Content: PropTypes.element,
  card4Action1: PropTypes.element,
  card1Content: PropTypes.element,
  title1: PropTypes.element,
  content1: PropTypes.element,
  date4: PropTypes.element,
  card2Heading: PropTypes.element,
  card2Action1: PropTypes.element,
}

export default Timeline4
